<template>
	<div >
		<img class="bg-img" src="@/assets/img/bg01.jpg" alt="" />
		<div class="cont">
			<div class="cont-img">
				<img  src="@/assets/img/userlogin.png" alt="" />
			</div>
			<div class="cont-form">
				<h2>后台管理系统</h2>
				<input type="text" placeholder="请输入账号" v-model="email" />
				<input type="password" placeholder="请输密码" v-model="password" />
				<button @click="login()">确定</button>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios'
export default{
		name:'LoginPage',
		data(){
			return{
				email:'',
				password:''
			}
		},
		methods:{
			login(){
				let This=this
				if(
				This.email==null|This.email==''|
				This.password==null|This.password==''
				){
					This.$message({
					    message: '表单为空!',
					    type: 'warning'
					});
				}else{
					axios(
						{
						  method:'post',
						  url: This.$store.state.ServerAddress+"/api/admin/login",
						  data : {
							  adminAccount:This.email,
							  adminPassword:This.password
						  },
						}
						).then((rest)=>{
							console.log(rest);
							if(rest.data.success){
								This.$message({
								message: '登录成功',
								type: 'success'
								});
								// console.log(rest.data.data.token);
								localStorage.setItem('UserEmail',This.email)
								localStorage.setItem('token',rest.data.data.accessToken)
								// console.log(rest.data.data.token);
								This.$router.push('/managementlist')
							}else{
								This.$message.error('验证失败');
							}
						},(err)=>{
							console.log(err);
							if (err.response && err.response.status === 403) {
								This.$message.error('验证失败');
							} else {
								This.$message.error('网络连接失败');
							}
						})
				}
			}
		}
	}
</script>

<style scoped>
	.bg-img{
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
	}
	.cont{
		position: absolute;
		z-index: 101;
		top: 50%;
		left: 50%;
		display: flex;
		justify-content: center;
		background-color: white;
		width: 50%;
		min-width: 400px;
		background-color: white;
		transform: translate(-50%, -50%);
		border-radius: 10px;
		padding: 20px;
	}
	.cont-img{
		width: 60%;
		margin: 0 auto;
	}
	.cont-img img{
		width: 100%;
		margin: 0 auto;
	}
	.cont-form{
		width: 40%;
		text-align: center;
	}
	.cont-form input , button{
		display: block;
		margin: 50px auto;
	}
	.cont-form input{
		padding: 10px;
		border: none;
		border-bottom: 1px solid #909399;
		background-color: white;
		outline: none;
	}
	.cont-form button{
		background-color: white;
		border: 1px solid #C0C4CC;
		padding: 5px 30px;
		font-size: 15px;
		border-radius: 10px;
	}
	.cont-form button:hover{
		background-color: #53a8ff;
		color: white;
	}
</style>